module.exports = __webpack_public_path__ + "images/emoji/mountain_bicyclist.d3948b782e75864519a9.png";